import { useEffect } from 'react';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { stringDateToDeliveryDay } from '../../utils/format-delivery-schedule.util';
import { DeliveryDay } from '../../types/delivery-selection.type';

type Props = {
  selectedDay: DeliveryDay | null;
  onDayChange: (day: DeliveryDay | null) => void;
};

const useStyles = makeStyles({
  root: {
    minWidth: 200,
  },
});

export function StoreDeliverySection({ selectedDay, onDayChange }: Props) {
  const classes = useStyles();

  useEffect(() => {
    if (!selectedDay) {
      onDayChange(stringDateToDeliveryDay(moment().format('YYYY-MM-DD')));
    }
  }, [selectedDay, onDayChange]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onDayChange(stringDateToDeliveryDay(event.target.value));
  };

  const dateValue = selectedDay?.date.format('YYYY-MM-DD') ?? moment().format('YYYY-MM-DD');

  return (
    <form noValidate className={classes.root}>
      <TextField
        label="Date de livraison"
        type="date"
        variant="outlined"
        size="small"
        value={dateValue}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
      />
    </form>
  );
}
